import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateVideoMutationVariables = Types.Exact<{
  testimonialId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  market: Types.Scalars['String']['input'];
  title: Types.Scalars['String']['input'];
  tags?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  videoThumbnailFileName: Types.Scalars['String']['input'];
  videoFileName: Types.Scalars['String']['input'];
  updatedBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pubshingDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  stopDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateVideoMutation = { __typename?: 'Mutation', updateTestimonial?: { __typename?: 'ResultResponse', count: number, error?: string | null } | null };


export const UpdateVideoDocument = gql`
    mutation UpdateVideo($testimonialId: Int, $market: String!, $title: String!, $tags: [Int!], $videoThumbnailFileName: String!, $videoFileName: String!, $updatedBy: String, $pubshingDate: String, $stopDate: String) {
  updateTestimonial(
    request: {testimonialId: $testimonialId, market: $market, title: $title, tags: $tags, videoThumbnailFileName: $videoThumbnailFileName, videoFileName: $videoFileName, updatedBy: $updatedBy, pubshingDate: $pubshingDate, stopDate: $stopDate}
  ) {
    count
    error
  }
}
    `;
export type UpdateVideoMutationFn = Apollo.MutationFunction<UpdateVideoMutation, UpdateVideoMutationVariables>;

/**
 * __useUpdateVideoMutation__
 *
 * To run a mutation, you first call `useUpdateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoMutation, { data, loading, error }] = useUpdateVideoMutation({
 *   variables: {
 *      testimonialId: // value for 'testimonialId'
 *      market: // value for 'market'
 *      title: // value for 'title'
 *      tags: // value for 'tags'
 *      videoThumbnailFileName: // value for 'videoThumbnailFileName'
 *      videoFileName: // value for 'videoFileName'
 *      updatedBy: // value for 'updatedBy'
 *      pubshingDate: // value for 'pubshingDate'
 *      stopDate: // value for 'stopDate'
 *   },
 * });
 */
export function useUpdateVideoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoMutation, UpdateVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoMutation, UpdateVideoMutationVariables>(UpdateVideoDocument, options);
      }
export type UpdateVideoMutationHookResult = ReturnType<typeof useUpdateVideoMutation>;
export type UpdateVideoMutationResult = Apollo.MutationResult<UpdateVideoMutation>;
export type UpdateVideoMutationOptions = Apollo.BaseMutationOptions<UpdateVideoMutation, UpdateVideoMutationVariables>;